require('./style.scss')
angular = require('angular')
pkg = angular.module 'cdms.device.configurator', []    
  .service "configurator", require('./configurator')
module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/configurator/index.coffee